<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="userData.permissions['view_student_attendance'] == 1"
    >
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <div>
                  <router-link to="/studentrollcall">
                    <b-button class="mx-2" size="lg" variant="info"
                      ><i class="mdi mdi-cellphone-nfc"></i> Attendance by
                      NFC</b-button
                    ></router-link
                  >
                  <router-link to="/">
                    <b-button class="mx-2" size="lg" variant="secondary"
                      ><i class="mdi mdi-fingerprint"></i> Attendance by
                      biometric</b-button
                    ></router-link
                  >
                </div>
              </div>
              <br />
              <div class="my-2" v-if="students.length <= 0">
                <div class="row align-items-end">
                  <b-form-group class="col-md-3 px-1" label="Class">
                    <v-select
                      :options="schoolclasses"
                      @input="FilterStreams"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3 px-1" label="Stream">
                    <v-select
                      :options="streams"
                      placeholder="Select Stream"
                      v-model="stream"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 px-1" label="Date">
                    <b-form-input
                      v-model="attendanceDate"
                      type="date"
                      :max="currentdate"
                    ></b-form-input>
                  </b-form-group>
                  <div class="col-md-2 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="LoadStudents()">
                      <i class="mdi mdi-account-search"></i> Load Students
                    </b-button>
                  </div>
                </div>
              </div>

              <div v-else>
                <div
                  class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2"
                >
                  <span class="h5 text-center mb-0">
                    Attendance &mdash;
                    <span class="text-primary">{{ schoolclass.name }}</span>
                    <span v-if="stream"> / {{ stream.name }}</span>
                    &nbsp;|&nbsp; {{ attendanceDate }}
                  </span>
                  <div class="d-flex gap-2">
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="MarkAll(true)"
                    >
                      <i class="mdi mdi-check-all"></i> Mark All Present
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="MarkAll(false)"
                    >
                      <i class="mdi mdi-close-box-multiple"></i> Clear All
                    </b-button>
                    <b-button
                      variant="outline-warning"
                      size="sm"
                      @click="ResetPage()"
                    >
                      <i class="mdi mdi-refresh"></i> Change Class
                    </b-button>
                  </div>
                </div>

                <div class="mb-3 d-flex gap-3 flex-wrap">
                  <span class="badge bg-success fs-6 px-3 py-2">
                    <i class="mdi mdi-account-check"></i>
                    Present: {{ presentCount }}
                  </span>
                  <span class="badge bg-danger fs-6 px-3 py-2">
                    <i class="mdi mdi-account-remove"></i>
                    Absent: {{ absentCount }}
                  </span>
                  <span class="badge bg-secondary fs-6 px-3 py-2">
                    <i class="mdi mdi-account-group"></i>
                    Total: {{ students.length }}
                  </span>
                </div>

                <div class="row mb-2">
                  <div class="col-sm-12 col-md-6">
                    <div class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show
                        <b-form-select
                          class="form-select form-select-sm mx-1"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select>
                        entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search student..."
                          class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-hover table-bordered align-middle">
                    <thead class="table-dark">
                      <tr>
                        <th style="width:50px">#</th>
                        <th style="width:70px">Photo</th>
                        <th>Student</th>
                        <th class="text-center" style="width:120px">Present</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(student, index) in paginatedStudents"
                        :key="student.id"
                        :class="
                          student.rollcall_status === 1 ? 'table-success' : ''
                        "
                        style="transition: background 0.2s;"
                      >
                        <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                        <td>
                          <img
                            :src="getFiles(student.student_id.student_photo)"
                            height="45"
                            class="rounded-circle"
                            style="object-fit:cover; width:45px;"
                          />
                        </td>
                        <td>
                          {{ student.student_id.first_name }}
                          {{ student.student_id.last_name }}<br />
                          <b class="text-danger">{{
                            student.student_id.student_id
                          }}</b>
                        </td>
                        <td class="text-center">
                          <div
                            class="attendance-checkbox-wrapper"
                            @click="toggleAttendance(student)"
                            style="cursor:pointer; display:inline-flex; align-items:center; justify-content:center;"
                          >
                            <div
                              :class="[
                                'attendance-box',
                                student.rollcall_status === 1
                                  ? 'checked'
                                  : 'unchecked',
                              ]"
                            >
                              <i
                                v-if="student.rollcall_status === 1"
                                class="mdi mdi-check-bold text-white"
                                style="font-size: 20px; line-height:1;"
                              ></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="paginatedStudents.length === 0">
                        <td colspan="6" class="text-center text-muted py-4">
                          No students found.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="filteredStudents.length"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-12 text-end">
                    <b-button
                      variant="success"
                      size="lg"
                      @click="SubmitAttendance()"
                      :disabled="isSubmitting"
                    >
                      <b-spinner small v-if="isSubmitting"></b-spinner>
                      <i class="mdi mdi-content-save-check" v-else></i>
                      &nbsp; Submit Attendance
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  userMethods,
  userComputed,
  schoolclassMethods,
  schoolclassComputed,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "System Attendance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Attendance",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " System Attendance", active: true },
      ],

      currentdate: new Date().toLocaleDateString("fr-CA"),
      attendance_id: "",
      schoolclass: "",
      streams: [],
      stream: "",
      attendanceDate: new Date().toISOString().split("T")[0],
      students: [],
      perPage: 50,
      pageOptions: [25, 50, 100, 200],
      currentPage: 1,
      filter: "",
      isSubmitting: false,
    };
  },
  computed: {
    ...schoolclassComputed,
    ...schooltermComputed,
    ...userComputed,

    presentCount() {
      return this.students.filter((s) => s.rollcall_status === 1).length;
    },
    absentCount() {
      return this.students.filter((s) => s.rollcall_status === 0).length;
    },

    filteredStudents() {
      if (!this.filter) return this.students;
      const q = this.filter.toLowerCase();
      return this.students.filter(
        (s) =>
          (s.student_id.first_name + " " + s.student_id.last_name)
            .toLowerCase()
            .includes(q) ||
          String(s.student_id.student_id)
            .toLowerCase()
            .includes(q),
      );
    },

    paginatedStudents() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredStudents.slice(start, start + this.perPage);
    },
  },
  mounted() {
    this.fetchSchoolClasses();
  },
  methods: {
    ...schoolclassMethods,
    ...schooltermMethods,
    ...userMethods,

    async FilterStreams() {
      this.stream = "";
      this.streams = [];
      if (!this.schoolclass) return;
      const url = `/findstream/${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.streams = response.data.streams;
      });
    },

    async LoadStudents() {
      if (!this.schoolclass) {
        this.$bvToast.toast("Please select a class.", {
          title: "Validation",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const formData = new FormData();
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("stream", this.stream ? this.stream.id : "");
      formData.append("date", this.attendanceDate);

      await axios.post("/loadattendancestudents", formData).then((response) => {
        // Check if attendance is already taken for this date
        if (response.data.already_taken) {
          this.$bvModal.msgBoxOk(response.data.message, {
            title: "Attendance Already Taken",
            titleTag: "h5",

            okVariant: "warning",
            okTitle: "OK, Got it",
            headerClass: "bg-warning text-dark",
            bodyClass: "text-dark fs-6",
            footerClass: "border-0",
            centered: true,
          });
          return;
        }

        // If no students are found
        if (response.data.no_students) {
          this.$bvModal.msgBoxOk(response.data.message, {
            title: "No Students Found",
            titleTag: "h5",
            okVariant: "info",
            okTitle: "OK",
            headerClass: "bg-info text-white",
            bodyClass: "text-dark fs-6",
            footerClass: "border-0",
            centered: true,
          });
          return;
        }

        // Store the attendance_id from backend (attendance record is created in DB)
        // But individual student attendance records are NOT saved yet
        this.attendance_id = response.data.attendance_id;

        // Store students with their current attendance status (if any)
        // The backend should return students with attendance = null or 0 for new records
        this.students = response.data.students.map((s) => ({
          ...s,
          rollcall_status: s.attendance ?? 0, // Use existing attendance if any, otherwise 0
        }));
        this.currentPage = 1;
      });
    },

    toggleAttendance(student) {
      student.rollcall_status = student.rollcall_status === 1 ? 0 : 1;
    },

    MarkAll(present) {
      this.students = this.students.map((s) => ({
        ...s,
        rollcall_status: present ? 1 : 0,
      }));
    },

    ResetPage() {
      this.students = [];
      this.streams = [];
      this.stream = "";
      this.schoolclass = "";
      this.currentPage = 1;
      this.filter = "";
      this.attendance_id = "";
    },

    getFiles(name) {
      const url = axios.defaults.baseURL;
      return url.slice(0, -3) + "students/" + name;
    },

    async SubmitAttendance() {
      this.isSubmitting = true;

      // Only proceed if there are students to save
      if (this.students.length === 0) {
        this.$bvToast.toast("No students to save attendance for.", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        this.isSubmitting = false;
        return;
      }

      // Only proceed if we have an attendance_id
      if (!this.attendance_id) {
        this.$bvToast.toast(
          "Attendance session not found. Please load students again.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          },
        );
        this.isSubmitting = false;
        return;
      }

      const payload = this.students.map((s) => ({
        student_id: s.student_id.student_id,
        rollcall_status: s.rollcall_status,
      }));

      const formData = new FormData();
      formData.append("attendance_id", this.attendance_id);
      formData.append("attendance", JSON.stringify(payload));
      formData.append("user", this.userData.user_id);

      await axios
        .post("/saveattendance", formData)
        .then((response) => {
          if (response.data.code === 200 || response.status === 200) {
            this.$bvToast.toast("Attendance saved successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });

            // Clear the page after successful save
            this.ResetPage();
          }
        })
        .catch(() => {
          this.$bvToast.toast("Failed to save attendance. Try again.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style scoped>
/* Attendance checkbox styling */
.attendance-box {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid #ced4da;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s, border-color 0.18s, transform 0.1s;
  background: #fff;
}

.attendance-box.checked {
  background: #28a745;
  border-color: #28a745;
  transform: scale(1.08);
}

.attendance-box.unchecked:hover {
  border-color: #28a745;
  background: #e9fbe9;
}

/* Highlight present rows */
.table-success td {
  background-color: #d4edda !important;
}

/* Smooth row transitions */
tbody tr {
  transition: background-color 0.2s;
}
</style>
